module.exports = __webpack_public_path__ + "img/estacionamientos-bicicletas.56558c10.svg";